const { party } = require('./base');

const commentParentType = {
  PAYMENT: 1,
  INVOICE: 2,
  WALLET: 3,
  PAYMENT_CONSIGNEE_DATUM: 4,
  INDENT:5,
};

const billType = {
  FREIGHT_BILL: 1,
  INVOICE: 2,
  PAYMENT: 3,
};

const commentParty = Object.assign({}, party);

const commentTitle = {
  ADDED_EXTRA_CHARGE: 'Extra charge',
  INVOICE_REMARK: 'Invoice Remarks',
  INVOICE_GENERATED: 'Invoice Generated',
  INVOICE_CANCELLED: 'Invoice Cancelled',
  INVOICE_REJECTED: 'Invoice Rejected',
  EPOD: 'Epod',
  WALLET_REVERSAL: 'Wallet Reversal',
  REVERT_CHARGE: 'REVERT CHARGE',
  WALLET_SETTLED: 'Wallet Settled',
};

module.exports = { commentParentType, commentParty, commentTitle, billType };
